import React from "react";
import { Baby, BookOpen, Palette, Music, Languages, Activity } from "lucide-react";

const programs = [
  {
    icon: Baby,
    title: "Early Childhood (2–4 yrs)",
    desc: "A gentle introduction to school life with songs, stories, sensory play and lots of warmth.",
    bg: "bg-light-blue",
  },
  {
    icon: BookOpen,
    title: "Kindergarten (4–6 yrs)",
    desc: "Pre-reading, pre-writing, number sense and confidence-building before primary school.",
    bg: "bg-soft-orange",
  },
  {
    icon: Activity,
    title: "Activity-Based Learning",
    desc: "Children learn by doing — hands-on projects, group work, outdoor play and exploration.",
    bg: "bg-light-green",
  },
  {
    icon: Languages,
    title: "Nepali + English",
    desc: "Bilingual classrooms so children stay connected to Nepali language while building English fluency.",
    bg: "bg-light-blue",
  },
  {
    icon: Palette,
    title: "Creativity & Art",
    desc: "Painting, craft, role-play and storytelling that grow imagination and self-expression.",
    bg: "bg-soft-orange",
  },
  {
    icon: Music,
    title: "Movement & Music",
    desc: "Daily movement, dance, rhymes and music to build coordination, rhythm and joy.",
    bg: "bg-light-green",
  },
];

const Programs = () => (
  <section id="programs" className="py-16 sm:py-24" data-testid="programs-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mb-12">
        <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Programs</span>
        <h2 className="font-heading text-3xl sm:text-4xl font-bold mt-2">
          A balanced day, every day
        </h2>
        <p className="mt-3 text-[color:var(--text-secondary)]">
          Our programs blend academic readiness with creativity, movement and social-emotional
          growth — so every child leaves school feeling capable and seen.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {programs.map((p, i) => (
          <div key={i} className={`card-soft p-7 ${p.bg}`} data-testid={`program-${i}`}>
            <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center mb-5">
              <p.icon className="text-brand-blue" size={26} />
            </div>
            <h3 className="font-heading font-bold text-lg mb-2">{p.title}</h3>
            <p className="text-sm text-[color:var(--text-secondary)] leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Programs;
